import { render, staticRenderFns } from "./AccountTypeSelect.vue?vue&type=template&id=1b773e62"
import script from "./AccountTypeSelect.vue?vue&type=script&lang=ts"
export * from "./AccountTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports